// extracted by mini-css-extract-plugin
export var icon = "_qu-0";